import type { MutableRefObject } from "react";
import type { GridApi } from "@mui/x-data-grid-premium";
import { TablePlugin, type EnabledTablePlugins } from "ui/molecules/TableGrids/types";
import useCopyToClipboard, { type CopyToClipboardSettings } from "./useCopyToClipboard";

export default function usePlugins(gridApiRef: MutableRefObject<GridApi>, pluginSettings: EnabledTablePlugins) {
    useCopyToClipboard(gridApiRef, pluginSettings[TablePlugin.CopyToClipboard] as CopyToClipboardSettings);
};
